import React, { useState, useLayoutEffect } from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  handleWrapper: {
    height: '55px',
    width: '10px',
    left: 'calc(100% - 10px)',
    top: 0,
    position: 'absolute',
    cursor: 'col-resize',
    zIndex: 101,
  },
  handle: {
    position: 'absolute',
    height: '10px',
    left: '50%',
    top: 'calc(50% - 5px)',
    width: '1px',
    color: 'red',
    backgroundColor: 'black',
  },
}))

const useResizeHandlerEffects = ({ colWidth, onSizeChange }) => {
  const [isResizing, setIsResizing] = useState(false)
  const [startWidth, setStartWidth] = useState(colWidth)
  const [startX, setStartX] = useState(0)
  const MIN_COL_WIDTH = 75

  const clearListeners = () => {
    window.removeEventListener('mousemove', dragListener)
    window.removeEventListener('mouseup', endDragListener)
  }

  const dragListener = (ev) => {
    if (ev.buttons === 0) {
      // mouse isn't clicked, end the drag
      setIsResizing(false)
    }
    if (isResizing) {
      const diff = ev.pageX - startX
      const newTargetWidth = startWidth + diff
      if (newTargetWidth >= MIN_COL_WIDTH) {
        onSizeChange(newTargetWidth)
      } else {
        onSizeChange(MIN_COL_WIDTH)
      }
    }
  }

  const endDragListener = (ev) => {
    if (isResizing) {
      setIsResizing(false)
      clearListeners()
    }
  }
  
  useLayoutEffect(() => {
    if (isResizing) {
      window.addEventListener('mousemove', dragListener)
      window.addEventListener('mouseup', endDragListener)
    } else {
      clearListeners()
    }
    return clearListeners
  }, [isResizing])

  const mouseDownHandler = (ev) => {
    setIsResizing(true)
    setStartWidth(colWidth)
    setStartX(ev.pageX)
  }

  return { mouseDownHandler }
}

const ResizeHandle = (props) => {
  const { colWidth, onSizeChange } = props
  const classes = useStyles()
  const { mouseDownHandler } = useResizeHandlerEffects({ colWidth, onSizeChange })

  return (
    <div
      className={classes.handleWrapper}
      onMouseDown={mouseDownHandler}
    >
      <div className={classes.handle} />
    </div>
  )
}

export default ResizeHandle
